import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import { addToastAction as addToast } from '@perpay-web/components/base/ToastProvider/useToastContext';
import {
    submitDefaultAddressSuccess,
    submitDefaultAddressError,
} from '@perpay-web/fintech/actions/entities/defaultAddress';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { fetchUserAddressDetailsReset } from '@perpay-web/hooks/actions/addressDetails';
import { handleError } from '@perpay-web/observable/operators/handleError';

export const submitDefaultAddress = (action$) =>
    action$.pipe(
        ofType(submitDefaultAddressSuccess().type),
        mergeMap(() => [
            routeToLocation(paths.profile.path),
            addToast({ message: 'Address updated' }),
            fetchUserAddressDetailsReset(),
        ]),
        handleError((error) => [submitDefaultAddressError(error)]),
    );
